import React, { useState, useEffect } from 'react';
import TR from './../../Trans';

function ExternalInfo() {

  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => { 
    setTimeout(() => { 
      setIsWaiting(false);
    }, 10000)
  }, []);

  const renderTitles = () => { 
    return <div>
      <h2 style={{display: isWaiting ? "block" : "none"}}>{TR.cm_wait}...</h2>
      <h2 style={{display: isWaiting ? "none" : "block"}}>{TR.cm_error_occurred}. {TR.cm_retry}.</h2>
    </div>
  }

  return (
    <div style={{ height: "100vh", width: "100%", textAlign: "center", zIndex: 99999999, position: "fixed", paddingTop:"10vh", top:0, background: "black" }}>
      {renderTitles()}
    </div>
  );
}

export default ExternalInfo;